import { render } from "./Create-new-gift-card-images.vue?vue&type=template&id=646b7fd0&scoped=true"
import script from "./Create-new-gift-card-images.vue?vue&type=script&lang=js"
export * from "./Create-new-gift-card-images.vue?vue&type=script&lang=js"

import "./Create-new-gift-card-images.vue?vue&type=style&index=0&id=646b7fd0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646b7fd0"]])

export default __exports__